import React from "react";
import { Box } from "@mui/material";

export default function VoidText({text, children}) {
  return (
    <Box
      sx={!!text ? {
        position: "relative",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#fff",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "200%",
          height: "200%",
          backgroundImage: `
            repeating-linear-gradient(
              -45deg,
              rgba(255, 0, 0, 0.05) 0,
              rgba(255, 0, 0, 0.05) 20px,
              transparent 20px,
              transparent 40px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent 0,
              transparent 20px,
              rgba(255, 0, 0, 0.05) 20px,
              rgba(255, 0, 0, 0.05) 40px
            )
          `,
          backgroundSize: "100px 100px",
          transform: "rotate(0deg)",
          zIndex: 0,
        },
        "& .overlayText": {
          position: "absolute",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          fontSize: "24px",
          color: "rgba(255, 0, 0, 0.1)",
          transform: "rotate(-45deg)",
          top: 0,
          left: "-70%",
          width: "200%",
          height: "200%",
          display: "flex",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 1,
        },
      }:{backgroundColor: '#FFF'}}
    >
        {!!text && 
      <div className="overlayText">
        {Array.from({ length: 400 }).map((_, i) => (
            <span key={i} style={{ margin: "0 10px" }}>
            {text}
          </span>
        ))}
      </div>
    }

      {/* Your actual app content can go here */}
      <Box sx={{ position: "relative", zIndex: 2, p: 0 }}>
        {children}
      </Box>
    </Box>
  );
}
